export const ANET_STATUS_COLORS = {
  New: "#3B82F6",
  InProgress: "#F59E0B",
  Underwriting: "#F59E0B",
  Approved: "#10B981",
  Declined: "#EF4444",
  Cancelled: "#F97316",
  Fraud: "#DC2626",
};

export const getAnetStatusColor = (status) => ANET_STATUS_COLORS[status] || "#6B7280";
